// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqResistanceBandsSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqResistanceBandsSVG(props: Props) {
  const {fill, width = 16, height = 16} = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M8 2C7.20435 2 6.44129 2.31607 5.87868 2.87868C5.31607 3.44129 5 4.20435 5 5V9V10H3V9V5C3 3.67392 3.52678 2.40215 4.46447 1.46447C5.40215 0.526784 6.67392 0 8 0C9.32608 0 10.5979 0.526784 11.5355 1.46447C12.4732 2.40215 13 3.67392 13 5V19C13 19.7956 13.3161 20.5587 13.8787 21.1213C14.4413 21.6839 15.2044 22 16 22C16.7956 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7956 19 19V15V14H21V15V19C21 20.3261 20.4732 21.5979 19.5355 22.5355C18.5979 23.4732 17.3261 24 16 24C14.6739 24 13.4021 23.4732 12.4645 22.5355C11.5268 21.5979 11 20.3261 11 19V5C11 4.20435 10.6839 3.44129 10.1213 2.87868C9.55871 2.31607 8.79565 2 8 2ZM4 13C3.46957 13 2.96086 13.2107 2.58579 13.5858C2.21071 13.9609 2 14.4696 2 15V18H6V15C6 14.4696 5.78929 13.9609 5.41421 13.5858C5.03914 13.2107 4.53043 13 4 13ZM1.17157 12.1716C1.92172 11.4214 2.93913 11 4 11C5.06087 11 6.07828 11.4214 6.82843 12.1716C7.57857 12.9217 8 13.9391 8 15V19V20H7H1H0V19V15C0 13.9391 0.421427 12.9217 1.17157 12.1716ZM17 4H16V5V9C16 10.0609 16.4214 11.0783 17.1716 11.8284C17.9217 12.5786 18.9391 13 20 13C21.0609 13 22.0783 12.5786 22.8284 11.8284C23.5786 11.0783 24 10.0609 24 9V5V4H23H17ZM18 9V6H22V9C22 9.53043 21.7893 10.0391 21.4142 10.4142C21.0391 10.7893 20.5304 11 20 11C19.4696 11 18.9609 10.7893 18.5858 10.4142C18.2107 10.0391 18 9.53043 18 9Z"
        fill={fill}
      />
    </svg>
  );
}

export default EqResistanceBandsSVG;
